"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _bonusSend = require("@/api/activity/bonusSend");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _PhoneUserSelect = _interopRequireDefault(require("@/components/PhoneUserSelect"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BonusSendRecordPane',
  components: {
    PhoneUserSelect: _PhoneUserSelect.default
  },
  props: {
    bonusSendId: {
      type: Number,
      default: null
    },
    bonusSendTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchForm: {
        userId: null,
        sendStatus: null,
        event: null,
        dateRange: []
      },
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      exportLoading: false,
      // 会员等级列表
      vipGradeList: [],
      // 图片路径
      imgPath: process.env.VUE_APP_COMMENT_IMAGE_URL,
      // 发放按钮loading状态
      resendLoading: false,
      // 重新发放对话框
      resendDialogVisible: false,
      // 当前操作的记录
      currentRecord: null
    };
  },
  mounted: function mounted() {
    if (this.bonusSendId) {
      this.loadVipGradeList();
      this.fetchData();
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    // 加载会员等级列表
    loadVipGradeList: function () {
      var _loadVipGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.records) {
                this.vipGradeList = response.records.map(function (grade) {
                  return {
                    id: grade.id,
                    name: grade.name
                  };
                });
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取会员等级列表失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadVipGradeList() {
        return _loadVipGradeList.apply(this, arguments);
      }
      return loadVipGradeList;
    }(),
    // 获取会员等级名称
    getUserRankName: function getUserRankName(userRank) {
      var grade = this.vipGradeList.find(function (g) {
        return g.id === userRank;
      });
      return grade ? grade.name : '-';
    },
    fetchData: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.tableLoading = true;
              _context2.prev = 1;
              params = {
                page: this.currentPage,
                limit: this.pageSize,
                bonusSendId: this.bonusSendId,
                userId: this.searchForm.userId,
                event: this.searchForm.event,
                sendStatus: this.searchForm.sendStatus
              };
              if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                params.startDate = this.searchForm.dateRange[0];
                params.endDate = this.searchForm.dateRange[1];
              }
              _context2.next = 2;
              return (0, _bonusSend.getBonusSendRecordList)(params);
            case 2:
              response = _context2.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取数据失败');
              }
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              this.$message.error('获取数据失败：' + _t2.message);
            case 4:
              _context2.prev = 4;
              this.tableLoading = false;
              return _context2.finish(4);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }(),
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handlePhoneUserSelect: function handlePhoneUserSelect() {
      // 选中用户即触发查询，提升体验
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        userId: null,
        sendStatus: null,
        event: null,
        dateRange: []
      };
      this.currentPage = 1;
      this.fetchData();
    },
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.exportLoading = true;
              _context3.prev = 1;
              this.$message.info('正在导出发放记录...');
              params = {
                bonusSendId: this.bonusSendId,
                userId: this.searchForm.userId,
                event: this.searchForm.event,
                sendStatus: this.searchForm.sendStatus
              };
              if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                params.startDate = this.searchForm.dateRange[0];
                params.endDate = this.searchForm.dateRange[1];
              }
              _context3.next = 2;
              return (0, _bonusSend.exportBonusSendRecord)(params);
            case 2:
              response = _context3.sent;
              if (response && response.code === 200) {
                this.$message.success(response.message || '数据导出中，请稍后查看下载文件');
              } else {
                this.$message.error(response.message || '导出失败');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              console.error('导出失败:', _t3);
              this.$message.error('导出失败：' + (_t3.message || '网络异常'));
            case 4:
              _context3.prev = 4;
              this.exportLoading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    formatTime: function formatTime(time) {
      if (!time) return '-';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 处理头像URL，确保正确的前缀
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      // 如果已经是http开头，直接返回
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) {
        return userpic;
      }
      // 否则添加前缀
      return this.imgPath + userpic;
    },
    // 获取会员等级标签类型
    getUserRankTagType: function getUserRankTagType(userRank) {
      var tagMap = {
        1: 'info',
        2: '',
        3: 'success',
        4: 'warning',
        5: 'danger'
      };
      return tagMap[userRank] || '';
    },
    // 获取发放状态标签类型
    getSendStatusTagType: function getSendStatusTagType(sendStatus) {
      if (sendStatus === 1) return 'success';
      if (sendStatus === 2) return 'danger';
      return 'warning';
    },
    // 获取发放状态文本
    getSendStatusText: function getSendStatusText(sendStatus) {
      if (sendStatus === 1) return '已发放';
      if (sendStatus === 2) return '发放失败';
      return '待发放';
    },
    // 获取事件类型文本
    getEventText: function getEventText(event) {
      var eventMap = {
        1: '注册',
        2: '一键领取',
        3: '领券中心',
        4: '私域领券',
        5: '问卷发放',
        6: '活动',
        7: '会员日'
      };
      return eventMap[event] || '-';
    },
    // 获取事件类型标签类型
    getEventTagType: function getEventTagType(event) {
      var tagMap = {
        1: 'success',
        2: 'primary',
        3: 'info',
        4: 'warning',
        5: 'danger',
        6: '',
        7: 'warning'
      };
      return tagMap[event] || '';
    },
    // 获取优惠券类型名称
    getCouponTypeName: function getCouponTypeName(couponType) {
      var typeMap = {
        1: '满减券',
        2: '折扣券',
        3: '代金券',
        4: '兑换券'
      };
      return typeMap[couponType] || '未知类型';
    },
    // 获取优惠券类型标签类型
    getCouponTypeTag: function getCouponTypeTag(couponType) {
      var tagMap = {
        1: 'primary',
        2: 'success',
        3: 'warning',
        4: 'info'
      };
      return tagMap[couponType] || '';
    },
    // 判断是否有发放失败的明细
    hasFailedItems: function hasFailedItems(record) {
      if (!record.items || record.items.length === 0) {
        return false;
      }
      return record.items.some(function (item) {
        return item.sendStatus === 2;
      });
    },
    // 获取失败明细数量
    getFailedItemsCount: function getFailedItemsCount(record) {
      if (!record.items || record.items.length === 0) {
        return 0;
      }
      return record.items.filter(function (item) {
        return item.sendStatus === 2;
      }).length;
    },
    // 处理重新发放
    handleResend: function handleResend(record) {
      this.currentRecord = record;
      this.resendDialogVisible = true;
    },
    // 确认重新发放
    confirmResend: function () {
      var _confirmResend = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.currentRecord) {
                _context4.next = 1;
                break;
              }
              this.$message.error('请选择要重新发放的记录');
              return _context4.abrupt("return");
            case 1:
              this.resendLoading = true;
              _context4.prev = 2;
              _context4.next = 3;
              return (0, _bonusSend.resendFailedBonusSendRecord)(this.currentRecord.id);
            case 3:
              response = _context4.sent;
              if (response.code === 200) {
                this.$message.success(response.message || '重新发放成功');
                this.resendDialogVisible = false;
                // 刷新数据
                this.fetchData();
              } else {
                this.$message.error(response.message || '重新发放失败');
              }
              _context4.next = 5;
              break;
            case 4:
              _context4.prev = 4;
              _t4 = _context4["catch"](2);
              console.error('重新发放失败:', _t4);
              this.$message.error('重新发放失败：' + (_t4.message || '网络异常'));
            case 5:
              _context4.prev = 5;
              this.resendLoading = false;
              return _context4.finish(5);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 4, 5, 6]]);
      }));
      function confirmResend() {
        return _confirmResend.apply(this, arguments);
      }
      return confirmResend;
    }()
  }
};